module.exports = __webpack_public_path__ + "fontawesome-webfont.139e74e298bca37a25d2.svg";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/vendors/ng-prime/fonts/fontawesome-webfont.svg?v=4.3.0
// module id = ../../../../../src/assets/vendors/ng-prime/fonts/fontawesome-webfont.svg?v=4.3.0
// module chunks = 2